exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswersList__AnswersList--2t-D4{\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}", ""]);

// exports
exports.locals = {
	"AnswersList": "AnswersList__AnswersList--2t-D4"
};